import { Injectable } from '@angular/core';
import { ApiConfig } from './api.config';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class SessaoPlenarioService extends ApiConfig {
  constructor(private http: HttpClient) {
    super();
  }
  listarVotoPartidoGrafico(idSessao) {
    try {
      return new Promise(async (resolve) => {
        this.http
          .post(
            'https://project-5082f113-c983-477a-973.uw.r.appspot.com/SessaoPlenario/ListarVotoPartidoGrafico',
            idSessao
          )
          .subscribe(
            (data) => {
              resolve(data);
            },
            (error) => {
              // alert(
                //'Ocorreu um erro ao se conectar ao servidor, verifique sua conexão e tente novamente.'
              // );
            }
          );
      });
    } catch (error) {
      alert(error);
    }
  }
  governismo(idSessao) {
    try {
      return new Promise(async (resolve) => {
        this.http
          .get(
            'https://project-5082f113-c983-477a-973.uw.r.appspot.com/SessaoPlenario/Governismo?idSessaoPlenaria=' + idSessao,
            idSessao
          )
          .subscribe(
            (data) => {
              resolve(data);
            },
            (error) => {
              // alert(
                //'Ocorreu um erro ao se conectar ao servidor, verifique sua conexão e tente novamente.'
              // );
            }
          );
      });
    } catch (error) {
      alert(error);
    }
  }

  listarVotoEstadoGrafico(idSessao) {
    try {
      return new Promise(async (resolve) => {
        this.http
          .post(
            'https://project-5082f113-c983-477a-973.uw.r.appspot.com/SessaoPlenario/listarVotoEstadoGrafico',
            idSessao
          )
          .subscribe(
            (data) => {
              resolve(data);
            },
            (error) => {
              // alert(
                //'Ocorreu um erro ao se conectar ao servidor, verifique sua conexão e tente novamente.'
              // );
            }
          );
      });
    } catch (error) {
      alert(error);
    }
  }

  listarVotoGeneroGrafico(idSessao) {
    try {
      return new Promise(async (resolve) => {
        this.http
          .post(
           'https://project-5082f113-c983-477a-973.uw.r.appspot.com/SessaoPlenario/listarVotoGeneroGrafico',
            idSessao
          )
          .subscribe(
            (data) => {
              resolve(data);
            },
            (error) => {
              // alert(
                //'Ocorreu um erro ao se conectar ao servidor, verifique sua conexão e tente novamente.'
              // );
            }
          );
      });
    } catch (error) {
      alert(error);
    }
  }
  listar(filtro) {
    return new Promise(async (resolve) => {
      // var ultimoFiltro = localStorage.getItem('FILTRO_LISTAR_SESSAOPLENARIO');
      // var dataUltimoFiltro = localStorage.getItem('DATA_LISTAR_SESSAOPLENARIO');
      // if (
      //   ultimoFiltro == JSON.stringify(filtro) &&
      //   dataUltimoFiltro ==
      //     new Date().toISOString().slice(0, 10).replace(/-/g, '')
      // ) {
      //   resolve(
      //     JSON.parse(localStorage.getItem('RESULTADO_LISTAR_SESSAOPLENARIO'))
      //   );
      // }
      // this.http;
      this.http
        .post('https://project-5082f113-c983-477a-973.uw.r.appspot.com/SessaoPlenario/Listar', filtro)
        .subscribe(
          (data) => {
            localStorage.setItem(
              'DATA_LISTAR_SESSAOPLENARIO',
              new Date().toISOString().slice(0, 10).replace(/-/g, '')
            );
            localStorage.setItem(
              'FILTRO_LISTAR_SESSAOPLENARIO',
              JSON.stringify(filtro)
            );
            localStorage.setItem(
              'RESULTADO_LISTAR_SESSAOPLENARIO',
              JSON.stringify(data)
            );
            resolve(data);
          },
          (error) => {
            // alert(
              //'Ocorreu um erro ao se conectar ao servidor, verifique sua conexão e tente novamente.'
            // );
          }
        );
    });
  }
  listarPorParlamentar(idParlamentar) {
    return new Promise(async (resolve) => {
      this.http
        .post('https://project-5082f113-c983-477a-973.uw.r.appspot.com/SessaoPlenario/ListarPorParlamentar', {
          idParlamentar,
        })
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {
            // alert(
              //'Ocorreu um erro ao se conectar ao servidor, verifique sua conexão e tente novamente.'
            // );
          }
        );
    });
  }

  listarPorProjetoLista(idProjeto:any[], processId) {
    return new Promise(async (resolve) => {
      this.http
        .post(
            `https://project-5082f113-c983-477a-973.uw.r.appspot.com/SessaoPlenario/ListarPorProjetoLista?processId=${processId}`, idProjeto
        )
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {
            // alert(
              //'Ocorreu um erro ao se conectar ao servidor, verifique sua conexão e tente novamente.'
            // );
          }
        );
    });
  }

  listarProgressoAprovada(idProjeto:any[]) {
    return new Promise(async (resolve) => {
      this.http
        .post(
            'https://project-5082f113-c983-477a-973.uw.r.appspot.com/SessaoPlenario/ListarProgressoAprovada', idProjeto
        )
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {
            // alert(
              //'Ocorreu um erro ao se conectar ao servidor, verifique sua conexão e tente novamente.'
            // );
          }
        );
    });
  }

  listarPorProjeto(idProjeto) {
    return new Promise(async (resolve) => {
      this.http
        .get(
            'https://project-5082f113-c983-477a-973.uw.r.appspot.com/sessaoPlenario/ListarPorProjeto?idProjeto=' +
            idProjeto
        )
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {
            // alert(
              //'Ocorreu um erro ao se conectar ao servidor, verifique sua conexão e tente novamente.'
            // );
          }
        );
    });
  }
  listarPorId(id) {
    return new Promise(async (resolve) => {
      this.http.get('https://project-5082f113-c983-477a-973.uw.r.appspot.com/SessaoPlenario/listarPorId?idSessao=' + id).subscribe(
        (data) => {
          resolve(data);
        },
        (error) => {
          //alert(
            //'Ocorreu um erro ao se conectar ao servidor, verifique sua conexão e tente novamente.'
          //);
        }
      );
    });
  }
  obter(id) {
    return new Promise(async (resolve) => {
      this.http.get('https://project-5082f113-c983-477a-973.uw.r.appspot.com/SessaoPlenario/Obter?id=' + id).subscribe(
        (data) => {
          resolve(data);
        },
        (error) => {
          //alert(
            //'Ocorreu um erro ao se conectar ao servidor, verifique sua conexão e tente novamente.'
          //);
        }
      );
    });
  }
  obterSessao(id) {
    return new Promise(async (resolve) => {
      this.http.get('https://project-5082f113-c983-477a-973.uw.r.appspot.com/SessaoPlenario/ObterSessaoPlenario?id=' + id).subscribe(
        (data) => {
          resolve(data);
        },
        (error) => {
          //alert(
            //'Ocorreu um erro ao se conectar ao servidor, verifique sua conexão e tente novamente.'
          //);
        }
      );
    });
  }
}
